import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateLoginSSO } from '../Services/loadOrder';
import toast,{ Toaster } from 'react-hot-toast';
import axios from 'axios';

const SSOResponsePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const runSSOValidation = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const encryptedSSO = urlParams.get('SSO_ID');

      if (!encryptedSSO) {
        toast.error('You are not authorized to use this portal. Please contact WIN.');
        return;
      }

      try {
       
        const validationResp = await validateLoginSSO(encryptedSSO);

        if (validationResp.success === true) {
          // If validationResp is true, it means the user is authorized
          localStorage.setItem("user", JSON.stringify(validationResp.data));
          console.log('SSO validation successful:', validationResp.data);
          navigate('/home');
          toast.success('SSO validation successful. Redirecting to home page...');
          return;
        }else if (validationResp.success === false) {
          toast.error('You are not authorized to use this portal. Please contact WIN.');
          return;
        } 

      } catch (error) {
        console.error('SSO validation error:', error);
        navigate('/error');
      }
    };

    runSSOValidation();
  }, [navigate]);

  return (
    <div>
      <Toaster position="top-right"  />
      <p>Validating your SSO credentials. Please wait...</p>
    </div>
  );
};

export default SSOResponsePage;
